import { render, staticRenderFns } from "./announcement-dialog.vue?vue&type=template&id=1eb284ee&scoped=true"
import script from "./announcement-dialog.vue?vue&type=script&lang=js"
export * from "./announcement-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb284ee",
  null
  
)

export default component.exports